import { render, staticRenderFns } from "./trawl-web-layout.vue?vue&type=template&id=d1d60472"
import script from "./trawl-web-layout.vue?vue&type=script&lang=js"
export * from "./trawl-web-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports